import * as mutationTypes from './mutation-types'

export default {
  [mutationTypes.USER_SET_TOKEN]: (state, token) => {
    state.authToken = token
  },
  [mutationTypes.USER_SET_USER]: (state, user) => {
    state.utilisateur = user
  },
  [mutationTypes.USER_SET_USER_AGENCY]: (state, agency) => {
    const utilisateur = {
      ...state.utilisateur,
      companies: [...state.utilisateur.companies]
    }
    const i = utilisateur.companies.findIndex((c) => c.id === agency.id)
    if (i === -1) {
      utilisateur.companies.push(agency)
    } else {
      utilisateur.companies.splice(i, 1, agency)
    }
    if (!utilisateur.company || utilisateur.company.id === agency.id) {
      utilisateur.company = agency
    }
    state.utilisateur = utilisateur
  },
  [mutationTypes.USER_ADD_PREV_LOGIN]: (state, { username }) => {
    if (state.prevLogin.indexOf(username) === -1) {
      state.prevLogin.push(username)
    }
  },
  [mutationTypes.USER_SET_ALTERATE_PROFILE]: (state, profile) => {
    state.alteredProfile = profile
  },
  [mutationTypes.USER_SET_ALTERATED_AGENCY]: (state, agency) => {
    state.alteredAgency = agency
  }
}
